import { useMutation } from "@tanstack/react-query";
import fetchData from "../fetcher";
import { ActivatePayload, ActivateResponse } from "./types";

const useActivate = () => {
    const { mutateAsync, data, isPending, error, isError } = useMutation({
        mutationKey: ["activate"],
        mutationFn: (body: ActivatePayload) => fetchData<ActivateResponse>("/iam/v4/auth/activate", { body, method: "POST" }),
    });

    return { activate: mutateAsync, data, isPending, error, isError };
}

export default useActivate